import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import DeviceConfig from '@devices/config';

const DetailPoster = styled.img<React.CSSProperties>`
  border-radius: ${20 * Screen.widthRatio}px;
  border: ${1 * Screen.widthRatio}px #6b6b6b;
  width: ${230 * Screen.widthRatio}px;
  display: block;
  height: ${350 * Screen.widthRatio}px;
  margin-top: ${40 * Screen.widthRatio}px;
  ${() => {
    return DeviceConfig.capabilities?.image?.disableFitCover
      ? ''
      : 'object-fit:cover';
  }};
`;

export default withImage(DetailPoster, true);
